import {
  biometricAuthApiBaseUrl,
  consentApiBaseUrl,
  customerProfileApiBaseUrl,
  dealerPreferencesApiBaseUrl,
  legalApiBaseUrl,
  webAuthnApiBaseUrl,
} from '../../util/url-helper/url-helper';
import { HttpService } from './http.service';

let contentfulService: HttpService | undefined;

const httpServices = new Map<string, HttpService>();
const httpServicesWithCredentials = new Map<string, HttpService>();

export function getHttpServiceWithCredentials(baseUrl?: string): HttpService {
  const _baseUrl = (baseUrl || process.env.NEXT_PUBLIC_BASE_URL) as string;
  if (!httpServicesWithCredentials.has(_baseUrl)) {
    httpServicesWithCredentials.set(_baseUrl, new HttpService(_baseUrl, true));
  }
  return httpServicesWithCredentials.get(_baseUrl) as HttpService;
}

export function getHttpService(baseUrl?: string): HttpService {
  const _baseUrl = (baseUrl || process.env.NEXT_PUBLIC_BASE_URL) as string;
  if (!httpServices.has(_baseUrl)) {
    httpServices.set(_baseUrl, new HttpService(_baseUrl, false));
  }
  return httpServices.get(_baseUrl) as HttpService;
}

export function getHttpServiceWithOptions(baseUrl?: string, withCredentials = false): HttpService {
  const _baseUrl = (baseUrl || process.env.NEXT_PUBLIC_BASE_URL) as string;
  if (!httpServices.has(_baseUrl)) {
    httpServices.set(_baseUrl, new HttpService(_baseUrl, withCredentials));
  }
  return httpServices.get(_baseUrl) as HttpService;
}

export function getContentfulService() {
  if (!contentfulService) {
    contentfulService = new HttpService(process.env.NEXT_PUBLIC_CONTENTFUL_BASE_URL, false);
  }

  return contentfulService;
}

export const getCustomerProfileHttpService = () => {
  const { baseUrl, withCredentials } = customerProfileApiBaseUrl();
  return getHttpServiceWithOptions(baseUrl, withCredentials);
};

export const getConsentHttpService = () => {
  const { baseUrl, withCredentials } = consentApiBaseUrl();
  return getHttpServiceWithOptions(baseUrl, withCredentials);
};

export const getDealerHttpService = () => {
  const { baseUrl, withCredentials } = dealerPreferencesApiBaseUrl();
  return getHttpServiceWithOptions(baseUrl, withCredentials);
};

export const getBiometricAuthHttpService = () => {
  const { baseUrl, withCredentials } = biometricAuthApiBaseUrl();
  return getHttpServiceWithOptions(baseUrl, withCredentials);
};

export const getWebAuthnHttpService = () => {
  const { baseUrl, withCredentials } = webAuthnApiBaseUrl();
  return getHttpServiceWithOptions(baseUrl, withCredentials);
};

export const getLegalHttpService = () => {
  const { baseUrl, withCredentials } = legalApiBaseUrl();
  return getHttpServiceWithOptions(baseUrl, withCredentials);
};
